export const CreateMatterDraftContentClientFacingFolderResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterDraftContentClientFacingFolderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentClientFacingFolderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentClientFacingFolderResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterWorkflowActorType;
(function (MatterWorkflowActorType) {
    MatterWorkflowActorType["MATTER_OWNER_INACTIVE_EVENT"] = "matterOwnerInactiveEvent";
    MatterWorkflowActorType["REFRESH_EVENT"] = "matterRefreshEvent";
})(MatterWorkflowActorType || (MatterWorkflowActorType = {}));
export var MatterWorkflowActorTypeParams_REFRESH_EVENT;
(function (MatterWorkflowActorTypeParams_REFRESH_EVENT) {
    MatterWorkflowActorTypeParams_REFRESH_EVENT["MATTER_NAME"] = "matterName";
    MatterWorkflowActorTypeParams_REFRESH_EVENT["MATTER_OWNER"] = "owner";
    MatterWorkflowActorTypeParams_REFRESH_EVENT["MATTER_REF"] = "matterRef";
    MatterWorkflowActorTypeParams_REFRESH_EVENT["REFRESH_DATE"] = "refreshDate";
})(MatterWorkflowActorTypeParams_REFRESH_EVENT || (MatterWorkflowActorTypeParams_REFRESH_EVENT = {}));
export const MatterWorkflowActorOutput_REFRESH_EVENTFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterWorkflowActorTypeParams_MATTER_OWNER_INACTIVE_EVENT;
(function (MatterWorkflowActorTypeParams_MATTER_OWNER_INACTIVE_EVENT) {
    MatterWorkflowActorTypeParams_MATTER_OWNER_INACTIVE_EVENT["MATTER_NAME"] = "matterName";
    MatterWorkflowActorTypeParams_MATTER_OWNER_INACTIVE_EVENT["MATTER_OWNER"] = "owner";
    MatterWorkflowActorTypeParams_MATTER_OWNER_INACTIVE_EVENT["MATTER_REF"] = "matterRef";
})(MatterWorkflowActorTypeParams_MATTER_OWNER_INACTIVE_EVENT || (MatterWorkflowActorTypeParams_MATTER_OWNER_INACTIVE_EVENT = {}));
export const MatterWorkflowActorOutput_MATTER_OWNER_INACTIVE_EVENTFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterWorkflowExecutionCreationContextFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterInstanceWorkflowExecutionRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var EntityRepositoryWorkflowExecutionStatus;
(function (EntityRepositoryWorkflowExecutionStatus) {
    EntityRepositoryWorkflowExecutionStatus["CONTEXT_CREATION_FAILED"] = "context_creation_failed";
    EntityRepositoryWorkflowExecutionStatus["CONTEXT_CREATION_SUCCEEDED"] = "context_creation_succeeded";
    EntityRepositoryWorkflowExecutionStatus["CREATED"] = "created";
    EntityRepositoryWorkflowExecutionStatus["EVALUATION_FAILED"] = "evaluation_failed";
    EntityRepositoryWorkflowExecutionStatus["EVALUATION_SUCCEEDED"] = "evaluation_succeeded";
    EntityRepositoryWorkflowExecutionStatus["FAILED"] = "FAILED";
    EntityRepositoryWorkflowExecutionStatus["STARTED"] = "started";
    EntityRepositoryWorkflowExecutionStatus["SUCCEEDED"] = "succeeded";
})(EntityRepositoryWorkflowExecutionStatus || (EntityRepositoryWorkflowExecutionStatus = {}));
export const MatterInstanceWorkflowExecutionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterWorkflowTriggerType;
(function (MatterWorkflowTriggerType) {
    MatterWorkflowTriggerType["MATTER_CREATED"] = "matter_created";
    MatterWorkflowTriggerType["MATTER_HEART_BEATED"] = "matter_heart_beated";
    MatterWorkflowTriggerType["MATTER_UPDATED"] = "matter_updated";
})(MatterWorkflowTriggerType || (MatterWorkflowTriggerType = {}));
export const MatterCustomDateFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CompactMatterContentBodyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterDraftContentModifyType;
(function (MatterDraftContentModifyType) {
    MatterDraftContentModifyType["ADD_BACKGROUND_ACCESS"] = "addBackgroundAccess";
    MatterDraftContentModifyType["ADD_CLIENT_FILE_ACCESS"] = "addClientFileAccess";
    MatterDraftContentModifyType["ADD_HIGHLY_CONFIDENTIAL_ACCESS"] = "addHighlyConfidentialAccess";
    MatterDraftContentModifyType["ADD_QUESTION"] = "addQuestion";
    MatterDraftContentModifyType["ADD_QUESTION_ACCESS"] = "addQuestionAccess";
    MatterDraftContentModifyType["ADD_QUESTION_ASSIGNMENT"] = "addQuestionAssignment";
    MatterDraftContentModifyType["ADD_QUESTION_LEGAL_NOTE"] = "addQuestionLegalNote";
    MatterDraftContentModifyType["ASSIGNEE"] = "assignee";
    MatterDraftContentModifyType["CREATE"] = "create";
    MatterDraftContentModifyType["CREATE_CLIENT_FACING_FOLDER"] = "createClientFacingFolder";
    MatterDraftContentModifyType["CREATE_LEGAL_ONLY_FOLDER"] = "createLegalOnlyFolder";
    MatterDraftContentModifyType["DELETE_CLIENT_FACING_FILE"] = "deleteClientFacingFile";
    MatterDraftContentModifyType["DELETE_CLIENT_FACING_FOLDER"] = "deleteClientFacingFolder";
    MatterDraftContentModifyType["DELETE_LEGAL_ONLY_FILE"] = "deleteLegalOnlyFile";
    MatterDraftContentModifyType["DELETE_LEGAL_ONLY_FOLDER"] = "deleteLegalOnlyFolder";
    MatterDraftContentModifyType["DELETE_QUESTION"] = "deleteQuestion";
    MatterDraftContentModifyType["REMOVE_BACKGROUND_ACCESS"] = "removeBackgroundAccess";
    MatterDraftContentModifyType["REMOVE_CLIENT_FILE_ACCESS"] = "removeClientFileAccess";
    MatterDraftContentModifyType["REMOVE_HIGHLY_CONFIDENTIAL_ACCESS"] = "removeHighlyConfidentialAccess";
    MatterDraftContentModifyType["REMOVE_QUESTION_ACCESS"] = "removeQuestionAccess";
    MatterDraftContentModifyType["REMOVE_QUESTION_ASSIGNMENT"] = "removeQuestionAssignment";
    MatterDraftContentModifyType["REORDER_QUESTIONS"] = "reorderQuestions";
    MatterDraftContentModifyType["SET_HIGHLY_CONFIDENTIAL"] = "setHighlyConfidential";
    MatterDraftContentModifyType["UNSET_HIGHLY_CONFIDENTIAL"] = "unsetHighlyConfidential";
    MatterDraftContentModifyType["UPDATE_BACKGROUND"] = "updateBackground";
    MatterDraftContentModifyType["UPDATE_CLIENT_FACING_FOLDER"] = "updateClientFacingFolder";
    MatterDraftContentModifyType["UPDATE_DETAIL"] = "updateDetail";
    MatterDraftContentModifyType["UPDATE_LEGAL_ONLY_FOLDER"] = "updateLegalOnlyFolder";
    MatterDraftContentModifyType["UPDATE_QUESTION"] = "updateQuestion";
    MatterDraftContentModifyType["UPDATE_QUESTION_LABELS"] = "updateQuestionLabels";
    MatterDraftContentModifyType["UPLOAD_CLIENT_FACING_FILE"] = "uploadClientFacingFile";
    MatterDraftContentModifyType["UPLOAD_LEGAL_ONLY_FILE"] = "uploadLegalOnlyFile";
})(MatterDraftContentModifyType || (MatterDraftContentModifyType = {}));
export const CompactMatterDraftContentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CompactMatterPublishedContentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterStatus;
(function (MatterStatus) {
    MatterStatus["INIT"] = "init";
    MatterStatus["IN_PROGRESS"] = "inProgress";
    MatterStatus["PUBLISHED"] = "published";
})(MatterStatus || (MatterStatus = {}));
export const CompactMatterFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CompactMatterContextFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRepositoryWorkflowVariableFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRepositoryWorkflowActorFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRepositoryEvaluator_BasicFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ActMatterInstanceWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BuildMatterInstanceWorkflowContextRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_MATCHED;
(function (BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_MATCHED) {
    BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_MATCHED["CURRENT_ACTUAL_VALUE"] = "current_actual_value";
    BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_MATCHED["EXPECTED_VALUE"] = "expected_value";
    BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_MATCHED["PREVIOUS_ACTUAL_VALUE"] = "previous_actual_value";
})(BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_MATCHED || (BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_MATCHED = {}));
export var BasicEntityRepositoryWorkflowEvaluatorParams_NUMBER_REACHED;
(function (BasicEntityRepositoryWorkflowEvaluatorParams_NUMBER_REACHED) {
    BasicEntityRepositoryWorkflowEvaluatorParams_NUMBER_REACHED["CURRENT_NUMBER"] = "current_number";
    BasicEntityRepositoryWorkflowEvaluatorParams_NUMBER_REACHED["OFFSET"] = "offset";
    BasicEntityRepositoryWorkflowEvaluatorParams_NUMBER_REACHED["TARGET_NUMBER"] = "target_number";
})(BasicEntityRepositoryWorkflowEvaluatorParams_NUMBER_REACHED || (BasicEntityRepositoryWorkflowEvaluatorParams_NUMBER_REACHED = {}));
export var BasicEntityRepositoryWorkflowEvaluatorType;
(function (BasicEntityRepositoryWorkflowEvaluatorType) {
    BasicEntityRepositoryWorkflowEvaluatorType["DATE_CADENCE_REACHED"] = "date_cadence_reached";
    BasicEntityRepositoryWorkflowEvaluatorType["DATE_REACHED"] = "date_reached";
    BasicEntityRepositoryWorkflowEvaluatorType["NUMBER_REACHED"] = "number_reached";
    BasicEntityRepositoryWorkflowEvaluatorType["VALUE_CHANGED"] = "value_changed";
    BasicEntityRepositoryWorkflowEvaluatorType["VALUE_MATCHED"] = "value_matched";
    BasicEntityRepositoryWorkflowEvaluatorType["VALUE_SET"] = "value_set";
})(BasicEntityRepositoryWorkflowEvaluatorType || (BasicEntityRepositoryWorkflowEvaluatorType = {}));
export var BasicEntityRepositoryWorkflowActorType;
(function (BasicEntityRepositoryWorkflowActorType) {
    BasicEntityRepositoryWorkflowActorType["ECHO"] = "echo";
    BasicEntityRepositoryWorkflowActorType["EMAIL"] = "email";
})(BasicEntityRepositoryWorkflowActorType || (BasicEntityRepositoryWorkflowActorType = {}));
export var BasicEntityRepositoryWorkflowActorParams_EMAIL;
(function (BasicEntityRepositoryWorkflowActorParams_EMAIL) {
    BasicEntityRepositoryWorkflowActorParams_EMAIL["BODY"] = "body";
    BasicEntityRepositoryWorkflowActorParams_EMAIL["CC_LIST"] = "cc_list";
    BasicEntityRepositoryWorkflowActorParams_EMAIL["SUBJECT"] = "subject";
    BasicEntityRepositoryWorkflowActorParams_EMAIL["TO_LIST"] = "to_list";
})(BasicEntityRepositoryWorkflowActorParams_EMAIL || (BasicEntityRepositoryWorkflowActorParams_EMAIL = {}));
export const BasicEntityRepositoryWorkflowActorOutput_EMAILFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var BasicEntityRepositoryWorkflowActorParams_ECHO;
(function (BasicEntityRepositoryWorkflowActorParams_ECHO) {
    BasicEntityRepositoryWorkflowActorParams_ECHO["MESSAGE"] = "message";
})(BasicEntityRepositoryWorkflowActorParams_ECHO || (BasicEntityRepositoryWorkflowActorParams_ECHO = {}));
export var BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED;
(function (BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED) {
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED["BEGIN_DATE"] = "begin_date";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED["CURRENT_DATE"] = "current_date";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED["INTERVAL"] = "interval";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED["INTERVAL_UNIT"] = "interval_unit";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED["LAST_REACHED_DATE"] = "last_reached_date";
})(BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED || (BasicEntityRepositoryWorkflowEvaluatorParams_DATE_CADENCE_REACHED = {}));
export var BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED;
(function (BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED) {
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED["CURRENT_DATE"] = "current_date";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED["LAST_REACHED_DATE"] = "last_reached_date";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED["OFFSET"] = "offset";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED["OFFSET_TIME_UNIT"] = "offset_time_unit";
    BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED["TARGET_DATE"] = "target_date";
})(BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED || (BasicEntityRepositoryWorkflowEvaluatorParams_DATE_REACHED = {}));
export var BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_CHANGED;
(function (BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_CHANGED) {
    BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_CHANGED["NEW_VALUE"] = "new_value";
    BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_CHANGED["OLD_VALUE"] = "old_value";
})(BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_CHANGED || (BasicEntityRepositoryWorkflowEvaluatorParams_VALUE_CHANGED = {}));
export const CreateMatterInstanceWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterInstanceWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterInstanceWorkflowExecutionForMatterRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterInstanceWorkflowExecutionForMatterResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EvaluateMatterInstanceWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadMatterInstanceWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadMatterInstanceWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RunMatterInstanceWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RunMatterInstanceWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterInstanceWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterInstanceWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterOwnerInactiveWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterRefreshWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadMatterInstanceWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterInstanceWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterDraftContentLegalOnlyFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterDraftContentLegalOnlyFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterDraftContentLegalOnlyFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterDraftContentLegalOnlyFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterPublishedLegalOnlyFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterPublishedLegalOnlyFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentLegalOnlyFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentLegalOnlyFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedLegalOnlyFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedLegalOnlyFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UploadMatterDraftContentLegalOnlyFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UploadMatterDraftContentLegalOnlyFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterDraftContentLegalOnlyFolderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterDraftContentLegalOnlyFolderResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterDraftContentLegalOnlyFolderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentLegalOnlyFolderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentLegalOnlyFolderResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CloseMatterOCEngagementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterOCEngagementConstant;
(function (MatterOCEngagementConstant) {
    MatterOCEngagementConstant["EXTRA_TYPE"] = "oc-engagement";
})(MatterOCEngagementConstant || (MatterOCEngagementConstant = {}));
export var OCUserOrGroupId;
(function (OCUserOrGroupId) {
    OCUserOrGroupId.visit = (value, visitor) => {
        if (value.userId !== undefined)
            return visitor.userId(value.userId);
        if (value.groupId !== undefined)
            return visitor.groupId(value.groupId);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(OCUserOrGroupId || (OCUserOrGroupId = {}));
export const OCUserOrGroupIdFilterSensitiveLog = (obj) => {
    if (obj.userId !== undefined)
        return { userId: obj.userId
        };
    if (obj.groupId !== undefined)
        return { groupId: obj.groupId
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: 'UNKNOWN' };
};
export var MatterOCEngagementStatus;
(function (MatterOCEngagementStatus) {
    MatterOCEngagementStatus["ASSIGNED"] = "assigned";
    MatterOCEngagementStatus["REVIEWED"] = "reviewed";
    MatterOCEngagementStatus["STARTED"] = "started";
    MatterOCEngagementStatus["SUBMITTED"] = "submitted";
})(MatterOCEngagementStatus || (MatterOCEngagementStatus = {}));
export const MatterOCEngagementDetailFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ocId && { ocId: OCUserOrGroupIdFilterSensitiveLog(obj.ocId)
    }),
});
export const MatterOCEngagementFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.detail && { detail: MatterOCEngagementDetailFilterSensitiveLog(obj.detail)
    }),
});
export const CloseMatterOCEngagementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterOCEngagementFilterSensitiveLog(obj.body)
    }),
});
export const GetMatterOCEngagementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterOCEngagementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterOCEngagementFilterSensitiveLog(obj.body)
    }),
});
export const ReassignMatterOCEngagementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.newOCId && { newOCId: OCUserOrGroupIdFilterSensitiveLog(obj.newOCId)
    }),
});
export const ReassignMatterOCEngagementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterOCEngagementFilterSensitiveLog(obj.body)
    }),
});
export const ReviewMatterOCEngagementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReviewMatterOCEngagementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterOCEngagementFilterSensitiveLog(obj.body)
    }),
});
export const StartMatterOCEngagementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.ocId && { ocId: OCUserOrGroupIdFilterSensitiveLog(obj.ocId)
    }),
});
export const StartMatterOCEngagementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterOCEngagementFilterSensitiveLog(obj.body)
    }),
});
export const SubmitMatterOCEngagementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SubmitMatterOCEngagementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterOCEngagementFilterSensitiveLog(obj.body)
    }),
});
export const WorkMatterOCEngagementRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const WorkMatterOCEngagementResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterOCEngagementFilterSensitiveLog(obj.body)
    }),
});
export const AddMatterDraftContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterQuestionSourceInfoForQuestionListFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterQuestionSourceType;
(function (MatterQuestionSourceType) {
    MatterQuestionSourceType["ADHOC"] = "Adhoc";
    MatterQuestionSourceType["QUESTION_LIST"] = "QuestionList";
})(MatterQuestionSourceType || (MatterQuestionSourceType = {}));
export const MatterQuestionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddMatterDraftContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddMatterQuestionsFromQuestionListRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddMatterQuestionsFromQuestionListResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AssignMatterDraftContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterConstant;
(function (MatterConstant) {
    MatterConstant["ENTITY_TYPE"] = "matter";
})(MatterConstant || (MatterConstant = {}));
export var MatterPermission;
(function (MatterPermission) {
    MatterPermission["ADMIN"] = "Admin";
    MatterPermission["CREATE_NEW_MATTER"] = "CreateNewMatter";
    MatterPermission["DELETE_INPROGRESS_MATTER"] = "DeleteInProgressMatter";
    MatterPermission["DELETE_MATTER"] = "DeleteMatter";
    MatterPermission["EDIT_MATTER"] = "EditMatter";
    MatterPermission["LEGAL"] = "Legal";
    MatterPermission["PUBLISH_MATTER"] = "PublishMatter";
    MatterPermission["READ_INPROGRESS_MATTER"] = "ReadInProgressMatter";
    MatterPermission["READ_MATTER"] = "ReadMatter";
})(MatterPermission || (MatterPermission = {}));
export const MatterOCEngagmentClosedEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterOCEngagementReassignedEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.oldOCId && { oldOCId: OCUserOrGroupIdFilterSensitiveLog(obj.oldOCId)
    }),
    ...(obj.newOCId && { newOCId: OCUserOrGroupIdFilterSensitiveLog(obj.newOCId)
    }),
});
export const MatterOCEngagmentStartedEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterOCEngagementSubmittedEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterOwnerValidationEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterOwnerReassignedEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionAssignmentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterQuestionAssignedEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterRefreshDateReachedEventDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterDomainEventData;
(function (MatterDomainEventData) {
    MatterDomainEventData.visit = (value, visitor) => {
        if (value.questionAssigned !== undefined)
            return visitor.questionAssigned(value.questionAssigned);
        if (value.refreshDateReached !== undefined)
            return visitor.refreshDateReached(value.refreshDateReached);
        if (value.ocEngagementStarted !== undefined)
            return visitor.ocEngagementStarted(value.ocEngagementStarted);
        if (value.ocEngagementReassigned !== undefined)
            return visitor.ocEngagementReassigned(value.ocEngagementReassigned);
        if (value.ocEngagementSubmitted !== undefined)
            return visitor.ocEngagementSubmitted(value.ocEngagementSubmitted);
        if (value.ocEngagementClosed !== undefined)
            return visitor.ocEngagementClosed(value.ocEngagementClosed);
        if (value.ownerInactive !== undefined)
            return visitor.ownerInactive(value.ownerInactive);
        if (value.ownerReassigned !== undefined)
            return visitor.ownerReassigned(value.ownerReassigned);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(MatterDomainEventData || (MatterDomainEventData = {}));
export const MatterDomainEventDataFilterSensitiveLog = (obj) => {
    if (obj.questionAssigned !== undefined)
        return { questionAssigned: MatterQuestionAssignedEventDataFilterSensitiveLog(obj.questionAssigned)
        };
    if (obj.refreshDateReached !== undefined)
        return { refreshDateReached: MatterRefreshDateReachedEventDataFilterSensitiveLog(obj.refreshDateReached)
        };
    if (obj.ocEngagementStarted !== undefined)
        return { ocEngagementStarted: MatterOCEngagmentStartedEventDataFilterSensitiveLog(obj.ocEngagementStarted)
        };
    if (obj.ocEngagementReassigned !== undefined)
        return { ocEngagementReassigned: MatterOCEngagementReassignedEventDataFilterSensitiveLog(obj.ocEngagementReassigned)
        };
    if (obj.ocEngagementSubmitted !== undefined)
        return { ocEngagementSubmitted: MatterOCEngagementSubmittedEventDataFilterSensitiveLog(obj.ocEngagementSubmitted)
        };
    if (obj.ocEngagementClosed !== undefined)
        return { ocEngagementClosed: MatterOCEngagmentClosedEventDataFilterSensitiveLog(obj.ocEngagementClosed)
        };
    if (obj.ownerInactive !== undefined)
        return { ownerInactive: MatterOwnerValidationEventDataFilterSensitiveLog(obj.ownerInactive)
        };
    if (obj.ownerReassigned !== undefined)
        return { ownerReassigned: MatterOwnerReassignedEventDataFilterSensitiveLog(obj.ownerReassigned)
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: 'UNKNOWN' };
};
export var MatterDomainEventType;
(function (MatterDomainEventType) {
    MatterDomainEventType["OC_ENGAGED"] = "ocEngaged";
    MatterDomainEventType["OC_ENGAGEMENT_REASSIGNED"] = "ocEngagementReassigned";
    MatterDomainEventType["OC_ENGAGEMENT_SUBMITTED"] = "ocEngagementSubmitted";
    MatterDomainEventType["OC_UNENGAGED"] = "ocUnengaged";
    MatterDomainEventType["OWNER_INACTIVE"] = "ownerInactive";
    MatterDomainEventType["OWNER_REASSIGNED"] = "ownerReassigned";
    MatterDomainEventType["QUESTION_ASSIGNED"] = "questionAssigned";
    MatterDomainEventType["REFRESH_DATE_REACHED"] = "refreshDateReached";
})(MatterDomainEventType || (MatterDomainEventType = {}));
export const MatterDomainEventFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.eventData && { eventData: MatterDomainEventDataFilterSensitiveLog(obj.eventData)
    }),
});
export const AccessRecordFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterLocationType;
(function (MatterLocationType) {
    MatterLocationType["COUNTRY"] = "country";
    MatterLocationType["SUB_COUNTRY"] = "subCountry";
    MatterLocationType["UNION"] = "union";
})(MatterLocationType || (MatterLocationType = {}));
export const MatterLocationValueFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterLocationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionLabelFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionLegalNoteFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterTopicFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterContentBodyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterDraftContentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterPublishedContentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.__do_not_delete3 && { __do_not_delete3: MatterDomainEventFilterSensitiveLog(obj.__do_not_delete3)
    }),
});
export const AssignMatterDraftContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.content && { content: MatterFilterSensitiveLog(obj.content)
    }),
});
export const BatchUpdatePermissionForMatterQuestionRequestItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchUpdatePermissionForMatterQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchUpdatePermissionForMatterQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.content && { content: MatterFilterSensitiveLog(obj.content)
    }),
});
export const BulkGetMatterDraftContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QuestionDownloadUrlFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BulkGetMatterDraftContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BulkGetMatterPublishedContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BulkGetMatterPublishedContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.matter && { matter: MatterFilterSensitiveLog(obj.matter)
    }),
});
export const CreateMatterDraftContentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterDraftContentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: MatterFilterSensitiveLog(obj.body)
    }),
});
export const CreateTemplateFromMatterQuestionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateTemplateFromMatterQuestionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.matter && { matter: MatterFilterSensitiveLog(obj.matter)
    }),
});
export const GetMatterDraftContentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentQuestionLegalNoteRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentQuestionLegalNoteResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentHistoryByVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentHistoryByVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.matter && { matter: MatterFilterSensitiveLog(obj.matter)
    }),
});
export const GetMatterPublishedContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentQuestionByVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentQuestionByVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentQuestionLegalNoteRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentQuestionLegalNoteResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentQuestionLegalNoteByVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedContentQuestionLegalNoteByVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPublishedMatterContentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPublishedMatterContentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GrantPermissionForHighlyConfidentialMatterRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GrantPermissionForHighlyConfidentialMatterResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GrantPermissionToTeamForMatterQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GrantPermissionToTeamForMatterQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.content && { content: MatterFilterSensitiveLog(obj.content)
    }),
});
export const MatterDraftContentHistoryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexMatterDraftContentHistoryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexMatterForSearchNewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexMatterForSmartSearchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterPublishedContentHistoryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexMatterPublishedContentHistoryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PermissionTeamToClientFacingFilesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PermissionTeamToClientFacingFilesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.content && { content: MatterFilterSensitiveLog(obj.content)
    }),
});
export const PublishMatterDraftContentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PublishMatterDraftContentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.matter && { matter: MatterFilterSensitiveLog(obj.matter)
    }),
});
export const PublishMatterOwnerReassignedDomainEventRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PublishMatterOwnerReassignedDomainEventResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutMatterDraftContentQuestionLegalNoteRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutMatterDraftContentQuestionLegalNoteResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReassignMatterOwnerRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReassignMatterOwnerResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RemoveMatterDraftContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RemoveMatterDraftContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RemoveMatterDraftContentQuestionAssignmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RemoveMatterDraftContentQuestionAssignmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReorderMatterDraftContentQuestionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReorderMatterDraftContentQuestionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RevokePermissionForHighlyConfidentialMatterRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RevokePermissionForHighlyConfidentialMatterResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RevokePermissionFromClientFacingFilesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RevokePermissionFromClientFacingFilesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.content && { content: MatterFilterSensitiveLog(obj.content)
    }),
});
export const RevokePermissionFromMatterQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RevokePermissionFromMatterQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.content && { content: MatterFilterSensitiveLog(obj.content)
    }),
});
export const SearchMatterDraftContentHistoryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterDraftContentHistoryResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterNewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterPendingActionStatus;
(function (MatterPendingActionStatus) {
    MatterPendingActionStatus["LEGAL"] = "Legal";
    MatterPendingActionStatus["NONE"] = "None";
    MatterPendingActionStatus["OUTSIDE_COUNSEL"] = "OutsideCounsel";
})(MatterPendingActionStatus || (MatterPendingActionStatus = {}));
export const MatterSearchItemNewFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterNewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterPublishedContentHistoryRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterPublishedContentHistoryResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SetMatterHighlyConfidentialRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SetMatterHighlyConfidentialResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterSmartSearchFilterFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SmartSearchMatterRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterSmartSearchItemType;
(function (MatterSmartSearchItemType) {
    MatterSmartSearchItemType["MATTER_BACKGROUND"] = "MatterBackground";
    MatterSmartSearchItemType["MATTER_CLIENT_FACING_FILE"] = "MatterClientFacingFile";
    MatterSmartSearchItemType["MATTER_LEGAL_ONLY_FILE"] = "MatterLegalOnlyFile";
    MatterSmartSearchItemType["MATTER_QUESTION"] = "MatterQuestion";
})(MatterSmartSearchItemType || (MatterSmartSearchItemType = {}));
export const MatterSmartSearchAttributesFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterSmartSearchResultItemType;
(function (MatterSmartSearchResultItemType) {
    MatterSmartSearchResultItemType["ANSWER"] = "ANSWER";
    MatterSmartSearchResultItemType["DOCUMENT"] = "DOCUMENT";
    MatterSmartSearchResultItemType["QUESTION_ANSWER"] = "QUESTION_ANSWER";
})(MatterSmartSearchResultItemType || (MatterSmartSearchResultItemType = {}));
export const MatterSmartSearchResultItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SmartSearchMatterResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnIndexMatterForSearchNewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnIndexMatterForSmartSearchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnsetMatterHighlyConfidentialRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnsetMatterHighlyConfidentialResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterBackgroundRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterBackgroundResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentQuestionLabelsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftContentQuestionLabelsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftDetailRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterDraftDetailResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.matter && { matter: MatterFilterSensitiveLog(obj.matter)
    }),
});
export const MatterTemplateRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddMatterTemplateMatterContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddMatterTemplateMatterContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BulkGetMatterTemplateMatterContentQuestionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BulkGetMatterTemplateMatterContentQuestionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterTemplateConstant;
(function (MatterTemplateConstant) {
    MatterTemplateConstant["ENTITY_TYPE"] = "matterTemplate";
})(MatterTemplateConstant || (MatterTemplateConstant = {}));
export const MatterTemplateMatterContentBodyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterTemplateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexMatterTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterTemplateSearchItemMatterContentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterTemplateSearchItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnindexMatterTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterTemplateMatterContentQuestionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterTemplateMatterContentQuestionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FlatEntityRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FlatEntityExtraRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateOCFirmGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FlatEntityExtraInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var OCFirmGroupConstant;
(function (OCFirmGroupConstant) {
    OCFirmGroupConstant["EXTRA_TYPE"] = "OCGroup";
})(OCFirmGroupConstant || (OCFirmGroupConstant = {}));
export const OCFirmGroupFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OCFirmGroupEntityExtraFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateOCFirmGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOCFirmGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOCFirmGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchOCFirmGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DocumentRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OCFirmGroupDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchOCFirmGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SoftDeleteOCFirmGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateOCFirmGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateOCFirmGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var OCFirmRealm;
(function (OCFirmRealm) {
    OCFirmRealm["OC_CENTRAL"] = "OCCentral";
    OCFirmRealm["PRIVATE"] = "Private";
})(OCFirmRealm || (OCFirmRealm = {}));
export const CreateOCFirmRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var OCFirmConstant;
(function (OCFirmConstant) {
    OCFirmConstant["TYPE"] = "OCFirm";
})(OCFirmConstant || (OCFirmConstant = {}));
export const OCFirmInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateOCFirmResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOCFirmRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOCFirmResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexOCFirmRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchOCFirmRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchOCFirmResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SoftDeleteOCFirmRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnIndexOCFirmRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateOCFirmRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateOCFirmResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateOCUserRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var OCUserConstant;
(function (OCUserConstant) {
    OCUserConstant["EXTRA_TYPE"] = "OCUser";
})(OCUserConstant || (OCUserConstant = {}));
export const OCFirmRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OCUserRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OCUserInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateOCUserResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetAllOCUserGroupMembershipRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetAllOCUserGroupMembershipResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOCUserRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOCUserResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexOCUserRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchOCUserRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchOCUserResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SoftDeleteOCUserRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnIndexOCUserRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateOCUserRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateOCUserResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
